<template>
  <section class="min-h-screen" style="display: flex;align-items: end;">
    <div class="row" style="flex:1;">
      <div class="col-xl-8 col-lg-11 mx-auto">
        <div class="row mx-auto">
          <div class="col-lg-8 col-md-7 mx-auto text-white text-end">
            <div class="position-relative height-control">
              <h1 class="title" style="font-size: 50px;"> آینده مالی درست <br class="d-md-block d-none"> با هوش مصنوعی ناباکو</h1>
              <h6 class="margin-top-div" style="line-height: 30px;">
                ما هوش مصنوعی را به عنوان ابزاری قدرتمند برای تغییر نحوه تصمیم‌گیری مالی شما طراحی و معرفی کرده ایم . با استفاده از الگوریتم‌های پیشرفته، داده‌های عظیم مالی را تجزیه و تحلیل می‌کنیم تا پیش‌بینی‌های دقیق و قابل اعتماد ارائه دهیم. چناجه در بازار های مالی  فعالیت می نمایید ، هوش مصنوعی ناباکو  برای کاهش ریسک و افزایش سود  شما را کمک می نماید  می‌کنند.
              </h6>
              <div style="z-index: 1;">
                <button class="btn-gold my-2"><a href="../sign-up" style="color: black; text-decoration: none;">شروع به استفاده از NABACO AI</a></button>
                <button class="btn-border-gold mx-3 my-2">مشاوره رایگان بگیرید</button>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-5 mx-auto" style="padding-bottom: -5px !important;">
            <img src="../assets/test/home-img.png" class="size-img" alt="">
          </div>
        </div>
      </div>
    </div>
  </section>
  <div class="row w-100 py-4 mx-0 px-0 text-white" style="background-color: #3a4375;">
      <div class="col-sm-4 text-center mx-auto">
        <FontAwesomeIcon icon="fa-solid fa-headset" class="text-white fs-3"/>
        پشتیبانی 24 ساعته
      </div>
      <div class="col-sm-4 text-center mx-auto">
        <FontAwesomeIcon icon="fa-solid fa-user-group" class="text-white fs-3"/>
        تیم متخصص و باتجربه
      </div>
      <div class="col-sm-4 text-center mx-auto">
        <FontAwesomeIcon icon="fa-solid fa-shield-halved" class="text-white fs-3"/>
        نگهداری امن دارایی
      </div>
  </div>
  <section class="d-flex align-items-center w-100" style="min-height: 90vh;">
    <div class="mx-auto mt-5 pt-5">
      <h2 class="title">همکاری انسان و هوش مصنوعی: آینده‌ای هوشمندتر و موثرتر</h2>
      <h5 style="font-weight: bold;" class="mt-4 d-md-block d-none">در دنیای امروز، ترکیب توانایی‌های انسانی و قدرت بی‌نظیر هوش مصنوعی، مرزهای جدیدی را در نوآوری و اثربخشی باز کرده است. <br>این همکاری نه تنها به معنای استفاده از ابزارهای هوشمند است، بلکه به معنای ایجاد یک هم‌زیستی متقابل است <br> که نقاط قوت انسان و ماشین را به یکدیگر پیوند می‌دهد.</h5>
      <h6 style="font-weight: bold;" class="mt-4 d-md-none d-block">در دنیای امروز، ترکیب توانایی‌های انسانی و قدرت بی‌نظیر هوش مصنوعی، مرزهای جدیدی را در نوآوری و اثربخشی باز کرده است. <br>این همکاری نه تنها به معنای استفاده از ابزارهای هوشمند است، بلکه به معنای ایجاد یک هم‌زیستی متقابل است <br> که نقاط قوت انسان و ماشین را به یکدیگر پیوند می‌دهد.</h6>
      <div class="row col-md-8 mx-auto mt-4">
        <div class="col-sm-6 mx-auto">
          <div class="card-1 bg-1 d-flex align-items-end">
            <div class="card p-3 text-end">
              <h5 style="font-weight: bold;">نقش انسان</h5>
              <span style="font-weight: bold; font-size: 14px;">انسان‌ها همچنان خلاقیت، تصمیم‌گیری‌های استراتژیک و حس همدلی را به ارمغان می‌آورند. توانایی درک عواطف، در نظر گرفتن ارزش‌ها و قضاوت‌های اخلاقی از ویژگی‌هایی است که تکنولوژی نمی‌تواند به طور کامل بازسازی کند.</span>
            </div>
          </div>
        </div>
        <div class="col-sm-6 mx-auto">
          <div class="card-1 bg-2 d-flex align-items-end my-md-0 my-3">
            <div class="card p-3 text-end">
              <h5 style="font-weight: bold;">نقش هوش مصنوعی</h5>
              <span style="font-weight: bold; font-size: 14px;">در مقابل، هوش مصنوعی قادر است با سرعت و دقت زیاد داده‌ها را تحلیل کند، الگوها را شناسایی نماید و پیش‌بینی‌های پیچیده‌ای ارائه دهد. این فناوری بارهای سنگین را از دوش انسان برداشته و زمان را برای تمرکز بر جنبه‌های حیاتی‌تر آزاد می‌کند.</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  
  <section class="d-flex align-items-center w-100" style="height: 100vh;background-color: #000;color: white;">
    <div class="mx-auto row">
      <div class="col-md-8 mx-auto">
        <h1 style="font-weight: bold;">دستیار ترید ناباکو</h1>
        <h5 class="mt-5">دستیار هوش مصنوعی ترید ناباکو، طراحی شده است تا به شما کمک کند در دنیای پیچیده و سریع معاملات مالی تصمیمات آگاهانه‌تر و موفق‌تری بگیرید. با استفاده از قدرت تجزیه و تحلیل داده‌های لحظه‌ای و پیش‌بینی‌های دقیق، این دستیار شما را برای افزایش بازدهی و کاهش ریسک معاملات مجهز می‌کند.</h5>
      </div>
      <div class="mt-4">
        <h6>با دستیار هوش مصنوعی ترید ناباکو، معاملات خود را هوشمندتر از همیشه انجام دهید. همین حالا <a href="../sign-up">ثبت نام</a> و از قدرت AI بهره‌مند شوید!</h6>
        <button class="btn-gold mt-5">
          <a href="https://survey.porsline.ir/s/sP04J912" style="color: black; text-decoration: none;">لینک آزمون</a>
        </button>
      </div>
    </div>
  </section>
  <section class="d-flex align-items-center w-100" style="height: 90vh;">
    <div class="mx-auto row col-md-8">
      <!-- <div class="col-md-5">
        <img src="../../public/img/img-1.jpg" class="w-100" alt="">
      </div> -->
      <div class="col-12 pe-5 my-xl-auto my-5">
        <h2 style="font-weight: bold;">توکنیزاسیون دارایی‌ها با NABACO AI</h2>
        <h4 style="font-weight: bold;">تبدیل دارایی‌ها به توکن روی بلاکچین، شفاف، امن و قابل رهگیری</h4>
        <div class="row mt-3">
            <h5 class="mt-1">
              در دنیای امروز، فناوری بلاکچین فقط مخصوص رمزارزها نیست. با توکنازیشن، می‌تونیم هر نوع دارایی (مثل ملک، سهام، قرارداد یا حتی آثار هنری) رو به یک توکن دیجیتال روی بلاکچین تبدیل کنیم. ناباکو با ارائه خدمات تخصصی توکنازیشن، به شما کمک می‌کنه تا دارایی‌هاتون رو به شکلی مدرن، شفاف و امن دیجیتالی کنید.
              <br>
              <br>
              <div class="row">
                <div class="col-lg-4 col-md-6 d-flex my-2">
                  <div class="card-2 p-4">
                    <h5 style="color: #2a377f; font-weight: bold;">۱. هدف‌گذاری هوشمند</h5>
                    <h6>با تبدیل دارایی‌ها به توکن دیجیتال، مسیر جذب سرمایه، نقدشوندگی و تنوع سرمایه‌گذاری را هموار کنید. ما در NABACO با طراحی مدل‌های توکنیزاسیون مثل مالکیتی، سودمحور و امنیتی، اهداف استراتژیک پروژه شما را به واقعیت تبدیل می‌کنیم.</h6>
                  </div>
                </div>
                <div class="col-lg-4 col-md-6 d-flex my-2">
                  <div class="card-2 p-4">
                    <h5 style="color: #2a377f; font-weight: bold;">۲. انتخاب زیرساخت مناسب</h5>
                    <h6>انتخاب بلاکچینی مانند اتریوم، پالیگان یا سولانا بر اساس نیاز پروژه شما و پیاده‌سازی استانداردهای حرفه‌ای توکن مثل ERC-20، ERC-721 و ERC-1155 .نتیجه؟ یک سیستم مقیاس‌پذیر، امن و سازگار با آینده.</h6>
                  </div>
                </div>
                <div class="col-lg-4 col-md-6 d-flex my-2">
                  <div class="card-2 p-4">
                    <h5 style="color: #2a377f; font-weight: bold;">۳. قراردادهای هوشمند، اعتماد بدون واسطه</h5>
                    <h6>با پیاده‌سازی قراردادهای خودکار، انتقال دارایی، پرداخت و انطباق قانونی بدون واسطه انجام می‌شود.همراه با سازوکارهای حکمرانی شفاف برای حفاظت از سرمایه‌گذاران و تصمیم‌گیری قابل اطمینان.</h6>
                  </div>
                </div>
                <div class="col-lg-4 col-md-6 d-flex my-2">
                  <div class="card-2 p-4">
                    <h5 style="color: #2a377f; font-weight: bold;">۴. انطباق قانونی جهانی</h5>
                    <h6>تضمین ثبت امن مالکیت و پیروی از قوانین بین‌المللی با کمک مشاوران حقوقی تخصصی در بلاکچین. اعتمادسازی، کاهش ریسک و آماده‌سازی برای رشد پایدار از همین‌جا آغاز می‌شود.</h6>
                  </div>
                </div>
                <div class="col-lg-4 col-md-6 d-flex my-2">
                  <div class="card-2 p-4">
                    <h5 style="color: #2a377f; font-weight: bold;">۵. توسعه پلتفرم و مدل درآمدی</h5>
                    <h6>از بازار خرید و فروش دارایی‌های دیجیتال گرفته تا سیستم‌های اجاره، استیکینگ و کسب درآمد مداوم. پلتفرمی شفاف و سودآور برای کاربران، سرمایه‌گذاران و کسب‌وکار شما.</h6>
                  </div>
                </div>
                <div class="col-lg-4 col-md-6 d-flex my-2">
                  <div class="card-2 p-4">
                    <h5 style="color: #2a377f; font-weight: bold;">۶. جذب سرمایه‌گذار با روایت قدرتمند</h5>
                    <h6>با محتوای حرفه‌ای مثل وایت‌پیپر و پرزنتیشن‌های جذاب، پیام پروژه‌تان را به شکلی قابل فهم و قانع‌کننده به سرمایه‌گذاران منتقل کنید.اعتماد، مشارکت و سرمایه‌گذاری از همین‌جا شروع می‌شود.</h6>
                  </div>
                </div>
              </div>
              <!-- <h4 style="font-weight: bold;">ویژگی‌های اصلی خدمات ما:</h4>
              <br>
              <ul>
                <li> ایجاد توکن سفارشی: طراحی و پیاده‌سازی توکن بر بستر بلاکچین (مثل Ethereum یا BNB Chain) با ویژگی‌های مورد نیاز شما.</li>
                <br>
                <li>امنیت و شفافیت بالا: تمام تراکنش‌ها و مالکیت‌ها در بلاکچین ثبت می‌شن و قابل پیگیری هستن.</li>
                <br>
                <li>قابل استفاده در بازار جهانی: توکن‌ها می‌تونن در پلتفرم‌های جهانی لیست و معامله بشن.</li>
                <br>
                <li>اتوماسیون قراردادها: با کمک قراردادهای هوشمند (Smart Contracts) فرآیندها خودکار و بدون واسطه انجام می‌شن.</li>
              </ul> -->
            </h5>
        </div>
      </div>
      
    </div>  
  </section>
  <section class="d-flex align-items-center w-100" style="min-height: 100vh;background-color: #000;color: white;">
    <div class="row container mx-auto">
      <div class="col-md-4 my-auto">
        <img src="../assets/logo.png" class="w-75" style="border-radius: 10px;" alt="">
      </div>
      <div class="col-md-8 text-end pt-md-0 pt-5" style="font-weight: bold;">
        <h2 class="mt-5" style="font-weight: bold;">آکادمی ناباکو پلی به سوی دانش و موفقیت</h2>
        <div class="row mt-5">
          <h5 class="mt-3">
              آکادمی ناباکوبه‌گونه‌ای طراحی شده است که به شما ابزارها و دانش مورد نیاز برای درک عمیق‌تر دنیای مالی و فناوری‌های پیشرفته را ارائه دهد. این بخش از سایت، یک مرکز آموزشی جامع است که منابع، دوره‌ها، و مقالاتی با کیفیت بالا در سه حوزه کلیدی سواد مالی، بلاکچین و هوش مصنوعی ارائه  می نماید.
          </h5>
          <h5 class="mt-4">اهداف آکادمی ناباکو:</h5>
          <h5 class="mt-3">
              <strong>افزایش دانش عمومی:</strong>ما معتقدیم که دانش قدرت است. هدف آکادمی ناباکو آموزش مفاهیم پیچیده به زبان ساده و قابل‌فهم است.
              <br>
              <br>
              <strong>توانمندسازی تریدرها و سرمایه‌گذاران:</strong>با ارائه اطلاعات عملی و کاربردی، به شما کمک می‌کنیم تصمیمات آگاهانه‌تری بگیرید.
              <br>
              <br>
              <strong>اتصال دانش به عمل:</strong>یادگیری مفاهیم به‌تنهایی کافی نیست؛ ما به شما کمک می‌کنیم که از آموخته‌ها در زندگی واقعی و معاملات مالی خود استفاده کنید
          </h5>
        </div>
      </div>
      <div class="col-1 d-md-block d-none"></div>
    </div>
  </section>
</template>
<script lang="ts">
import { library } from '@fortawesome/fontawesome-svg-core';
import { faHeadset, faShieldHalved, faUserGroup } from '@fortawesome/free-solid-svg-icons';
import { defineComponent } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
// import Slider from './slider.vue';

export default defineComponent({
components: {FontAwesomeIcon},
setup(){
  library.add(faShieldHalved,faUserGroup,faHeadset)

  window.onscroll = function () {
    let myNav = document.getElementById('myNav')
    if (myNav) { // Ensure the element exists before applying class
      if (document.body.scrollTop >= 50 || document.documentElement.scrollTop >= 50) {
        myNav.classList.add("nav-colored");
      } else {
        myNav.classList.remove("nav-colored");
      }
    }
};
  
  return{
  }
}

})
</script>

<style lang="scss" scoped>

.min-h-screen {
  min-height: 92vh;
  background: linear-gradient(90deg, var(--blue) 0%, #000 100%);
  overflow-x: hidden;
  @media(max-width:1300px) {
    min-height: 65vh !important;
  }
}

.title {
  font-weight: bold;
  @media(max-width:1300px) {
    font-size: 35px !important;
  }
  @media(max-width:765px) {
    font-size: 30px !important;
  }
}
.card-1 {
border: none;
border-radius: 10px;
height: 350px !important;
height: 100%;
padding-bottom: 15px;
padding-left: 15px;
padding-right: 15px;
}

.height-control {
  top: -40px;
  @media(max-width:1300px) {
    top: 80px;
  }
  @media(max-width:1150px) {
    top: 18px;
  }
  @media(max-width:991px) {
    top: 60px;
  }
  @media(max-width:765px) {
    top: 10px;
  }
  @media(max-width:540px) {
    top: 60px;
  }
}

.bg-1{
background-image: url('../assets/test/AcademyBg.png');
background-size: cover;
}
.bg-2{
background-image: url('../assets/test/FirstSection.png');
background-size: cover;
}
.bg-3{
background-image: url('../assets/test/BoxBg.png');
background-size: cover;
}

.card-light {
background-color: rgb(245 245 245);
border: solid 2px rgb(224 224 224);
border-radius: 20px;
padding: 15px;
width: 100%;
}

.blog{
border: solid 1px #e9e9e9;
border-radius: 10px;
}

.size-img {
  width: 100%;
  @media(max-width:767px) {
    margin-top: 20px;
    width: 25%;
  }
}

.card-2 {
  background-color: #e7ebff;
  border: none;
  border-radius: 10px;
  // box-shadow: 0px 0px 10px 0px #000;
}
</style>